import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";


export default defineType({
  name: "flightPackage",
  title: "Flight Package",
  type: "object",

  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  },

  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "icon",
      title: "Icon",
      type: "designSystemIcon",
      validation: (Rule) => Rule.required()
    },

    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required()
    },

    {
      name: "inclusions",
      title: "Inclusions",
      type: "array",
      of: [{ type: "string" }],
      options: {
        list: ["Transfer", "Hotel"],
        layout: "checkbox"
      }
    }
  ]
});
